import { render, staticRenderFns } from "./DocumentDelete.vue?vue&type=template&id=5bd94b50&scoped=true"
import script from "./DocumentDelete.vue?vue&type=script&lang=js"
export * from "./DocumentDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd94b50",
  null
  
)

export default component.exports